import React from 'react';
import GenericModal, { IGenericModalProps } from './../GenericModal/GenericModal';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from './../../store/modules/ModalsActionTypes';
import { IModalProps } from './../../store/modules/ModalsReducer';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { useTranslation } from 'react-i18next';
import { Grid } from '@material-ui/core';
import { useStyles } from './styles'
import { IAssembleiaAssociadoPautaOpcao } from 'store/modules/AssembleiasAssociadoReducer';
import { IAssembleiasAssessorItens } from 'store/modules/AssembleiasAssessorReducer';
import { TipoCargosChapa } from 'enuns/TipoCargosChapa';

export interface IPautaEleicaoGenericProps extends IGenericModalProps {
  item: IAssembleiaAssociadoPautaOpcao | IAssembleiasAssessorItens,
  key: string
}

export interface IPautaEleicao extends IModalProps {
  genericProps: IPautaEleicaoGenericProps,
  modalsActionsClose: (key: string) => ModalsActionsClose
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  modalsActionsClose
}, dispatch);

const PautaEleicao = ({ genericProps }: IPautaEleicao) => {

  const { t } = useTranslation();
  const classes = useStyles();
  const dispatchAction = useDispatch();

  const toClose = (): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  }

  const getPresidente = () => {
    let nomePresidente: string = '';
    
    genericProps.item.representantesChapa.filter((it, key) => it.nomeCargo === TipoCargosChapa.Presidente).forEach(it => nomePresidente = it.associado)

    return (
      <Grid item xs={12} sm={12} md={12} lg={12} >
        <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.subTitle }>
          <b>{ t("PautaEleicaoModal.presidente") }</b>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.itemEleicao }>
          <div className={ classes.itemText }>{ nomePresidente !== '' ? nomePresidente : t("PautaEleicaoModal.noPresidente") }</div>
        </Grid>
      </Grid>
    )
  }

  const getVice = () => {
    let nomeVice: string = '';

    genericProps.item.representantesChapa.filter((it, key) => it.nomeCargo === TipoCargosChapa.Vice_Presidente).forEach(it => nomeVice = it.associado)

    return (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.subTitle }>
          <b>{ t("PautaEleicaoModal.vice") }</b>
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.itemEleicao }>
          <div className={ classes.itemText }>{ nomeVice !== '' ? nomeVice : t("PautaEleicaoModal.noVice") }</div>
        </Grid>
      </Grid>
    )
  }

  const getConselheiros = () => {
    let nomesConselheiros: string[] = [];

    genericProps.item.representantesChapa.filter((it, key) => it.nomeCargo === TipoCargosChapa.Conselheiro).forEach((it, index) => nomesConselheiros[index] = it.associado);

    return (
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.subTitle }>
          <b>{ t("PautaEleicaoModal.conselheiro") }</b>
        </Grid>
        {
          nomesConselheiros.length > 0 ?
            nomesConselheiros.map((it, index) => {
              return <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.itemEleicao } key={index}>
                      <div className={ classes.itemText }>{ it }</div>
                    </Grid>
            })
          :
            <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.itemEleicao }>
              <div className={ classes.itemText }>{ t("PautaEleicaoModal.noConcelheiro") }</div>
            </Grid>
        }
      </Grid>
    )
  }

  return (
    <GenericModal
      title={ `${ t("PautaEleicaoModal.title") } ${ genericProps.item.descricao }` }
      content={(
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            {
              getPresidente()
            }
            {
              getVice()
            }
            {
              getConselheiros()
            }
          </Grid>
        </Grid>
      )}
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  )
}

export default connect(null, mapDispatchToProps)(PautaEleicao);
